export const FORM_STATES = {
	DATA: 'DATA',
	CONFIRMATION: 'CONFIRMATION',
	LOADING: 'LOADING',
	SUCCESS: 'SUCCESS',
	ERROR: 'ERROR'
};

export const ANALITICS_FORMAT_OPTIONS = [
	{
		key: 'PDF',
		value: 'PDF'
	},
	{
		key: 'CSV',
		value: 'CSV'
	}
];

export const FREQUENCY_OPTIONS = [
	{
		key: 'DAILY',
		value: 'napi'
	},
	{
		key: 'WEEKLY',
		value: 'heti'
	},
	{
		key: 'MONTHLY',
		value: 'havi'
	}
];
